import { render } from "./Builder.vue?vue&type=template&id=50eb6abc"
import script from "./Builder.vue?vue&type=script&lang=js"
export * from "./Builder.vue?vue&type=script&lang=js"

import "@/assets/scss/views/Builder.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script